/** AIAgentScheduleInternalTaskTriggerType — how a task was materialized. */
export default Object.freeze({
  Scheduled: 1,
  Manual: 2,
});
